import React from 'react';
import { ProgressBar } from 'primereact/progressbar';

export const IndeterminateLoader = ({ height, backgroundColor, ...rest }) => {
  return (
    <div data-testid="indeterminateLoader">
      <ProgressBar
        mode={'indeterminate'}
        style={{ height: `${height}`, backgroundColor: `${backgroundColor}` }}
        {...rest}
      />
    </div>
  );
};
